var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousActiveIIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_4369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58203 0.441406L1.58203 5.44141L6.58203 10.4414L8.45703 8.56641L5.33203 5.44141L8.45703 2.31641L6.58203 0.441406Z",
    fill: "#1F2024"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_4369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0.332031 0.441406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousActiveIIcon);
export default __webpack_public_path__ + "static/media/previousActiveIIcon.c63333b4f8ff2064e3b6c547ae529cae.svg";
export { ForwardRef as ReactComponent };